/**
 * Shared enum types for survey system
 * Centralizes commonly used enum values to ensure consistency across the application
 */

/**
 * Question type for custom surveys
 */
export enum QuestionType {
  LIKERT_SCALE = 'LIKERT_SCALE',
  NPS_SCALE = 'NPS_SCALE',
  YES_NO = 'YES_NO',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
  SHORT_TEXT = 'SHORT_TEXT',
  LONG_TEXT = 'LONG_TEXT',
}

/**
 * Chart type for visualizing survey results
 */
export enum ChartType {
  NPS_GAUGE = 'NPS_GAUGE',
  NPS_BAR = 'NPS_BAR',
  BAR = 'BAR',
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
  DONUT = 'DONUT',
}

/**
 * Survey analysis status
 */
export enum AnalyzeStatus {
  NOT_ANALYZED = 'NOT_ANALYZED',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  INVALID_RESPONSE_RATE = 'INVALID_RESPONSE_RATE',
}

/**
 * Survey scheduling frequency
 */
export enum SurveyFrequency {
  WEEKLY = 'weekly',
  EVERY_OTHER_WEEK = 'everyOtherWeek',
  EVERY_THIRD_WEEK = 'everyThirdWeek',
  MONTHLY = 'monthly',
  EVERY_OTHER_MONTH = 'everyOtherMonth',
}
